export default "__VITE_ASSET__XnxRIqKU__"